<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import i18n from '@/localization/i18n';
import { navigate } from 'vike/client/router';
import Link from '@/views/components/Link.vue';
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide } from "vue3-carousel";

const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL

const t = i18n.global.t

let activeSlide = ref(0)
const slideItemsPerPage = ref(3)
const isClient = ref(false)

const checkScreenSize = () => {
    if (window.innerWidth <= 600) {
        slideItemsPerPage.value = 1
    } else if (window.innerWidth >= 600 && window.innerWidth <= 992) {
        slideItemsPerPage.value = 2
    } else if (window.innerWidth > 992) {
        slideItemsPerPage.value = 3
    }
}

onMounted(() => {
    isClient.value = true
    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)
})

onUnmounted(() => {
    window.removeEventListener('resize', checkScreenSize)
})


const articles = ref([
    {
        id: 15,
        title: 'Logiciel de devis pour plâtriers-plaquistes | Topela',
        description: "Gagnez du temps avec Topela, le logiciel de devis et de facturation conçu pour les plâtriers-plaquistes. Devis automatisés, conformité aux normes du bâtiment, suivi des paiements. Essai gratuit de 14 jours !",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/plaquiste1000x600.webp`,
        category: 'Logiciels',
        path: '/blog/logiciels/logiciel-devis-platrier-plaquiste/',
        publish_date: '30/06/2025'
    },
    {
        id: 16,
        title: 'Logiciel de devis pour artisans TCE | Topela',
        description: "Découvrez les avantages d’un logiciel de devis-facturation pour votre activité d’artisan TCE ou rénovateur. Gagnez du temps, structurez vos chantiers, améliorez votre gestion.",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/ArtisanTCE_DevisEnLigne_1000x600.webp`,
        category: 'Logiciels',
        path: '/blog/logiciels/logiciel-devis-artisan-tce/',
        publish_date: '17/07/2025'
    },
    {
        id: 17,
        title: 'Optimisez la gestion de votre activité professionnelle : gagnez du temps et de l’argent',
        description: "Organisation, chantiers, finances : découvrez comment mieux gérer votre activité dans le bâtiment pour gagner du temps et améliorer votre rentabilité.",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/desktop-mobile-16x5-quelStatutEntrepreneur.jpg`,
        category: 'Conseils',
        path: '/blog/conseils/optimiser-la-gestion-de-votre-activite-professionnelle/',
        publish_date: '26/12/2025'
    },
    {
        id: 18,
        title: 'Topela x Pennylane : une connexion pensée pour faire gagner du temps aux pros et artisans',
        description: "Découvrez comment la connexion entre Topela et Pennylane facilite la transmission des factures, simplifie le pilotage de l’activité et fluidifie la collaboration avec le cabinet comptable.",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/thumbnail-16x9-topela-pennylane.webp`,
        category: 'Conseils',
        path: '/blog/conseils/topela-pennylane-gestion-facturation/',
        publish_date: '02/05/2026'
    }
])

const navigate_to_article = async (path: string) => {
    await navigate(path)
}
</script>

<template>
    <div id="blog" class="my-5">
        <div class="container">
            <h2  class="h-style h2-style use-poppins text-center mb-5 fw-semibold">
                {{ t('w_txt_psHome_blog_heading') }}
            </h2>

            <!-- Articles Carousel -->
            <div class="row">
                <Carousel :autoplay="isClient ? 4000 : 0" :itemsToShow="slideItemsPerPage" :transition="700" :wrap-around="true"
                    snapAlign="start" v-model="activeSlide">
                    <Slide v-for="(article, _) in articles" :key="article.id" class="col-lg-4 mb-5 py-3">
                        <div class="px-3 d-flex flex-column h-100">
                            <img class="rounded-3 w-100 mb-4 cursor-pointer" :src="article.image" alt="Card image cap"
                                style="aspect-ratio: 16 / 9; height: 220px !important; object-fit: cover;"
                                @click="navigate_to_article(article.path)" />
                            <div class="flex-grow-1">
                                <h4 class="cursor-pointer align-text-left" @click="navigate_to_article(article.path)">
                                    {{ article.title }}
                                </h4>
                                <p class="align-text-left sized-text">
                                    {{ article.description }}
                                </p>
                                <small class="mt-2 article-date" style="font-size: 14px;">
                                    <strong>{{ t('g_txt_published_on') }} {{ article.publish_date }}</strong>
                                </small>
                            </div>

                        </div>
                    </Slide>
                </Carousel>
            </div>

            <div class="d-flex justify-content-center mt-0 pt-3">
                <Link href="/blog/" class="btn primary-btn text-white btn-text-visibility rounded px-5">

                {{ t('w_act_psHome_access_blog') }}
                </Link>
            </div>
        </div>
    </div>
     <section class="py-0 bg-info" >
        <div class="container py-5 custom-max-width text-center text-md-start" >
          <div class="row d-flex align-items-center ">
          <div class="col-12 col-md-8 ">
            <h3 class=" fw-bold fs-1 h-style h2-style use-poppins display-4">{{ t("w_txt_psPro_question_topela_pro") }}</h3>
            <p class=" fs-4" style="font-size: 16px">{{ t("w_txt_psPro_support_info") }}</p>
         </div>
         <div class="col-12 col-md-4">
          <a class="btn btn-dark bg-dark-blue rounded  btn-height btn-text-visibility d-block mx-auto mt-4" href="/contact/">
              {{ t('w_act_home_support_section_cta') }} </a>
            <p class="mb-0 small">
          {{ t('w_txt_home_support_section_cta_subtext') }}
          
          <strong>{{ t('w_txt_home_support_section_cta_subtext_value') }}</strong>
        </p>
         </div>
         </div>
        </div>
      </section>

</template>

<style scoped>
@import url('@/assets/css/bootstrap-extended.css');
@import url('@/assets/css/animate.css');
@import url('@/assets/css/main.css');
@import url('@/assets/css/responsive.css');

.primary-btn {
    background-color: #49AFDA;
    color: white;
    border-radius: 10px;
    font-size: 20px !important;
}
.primary-btn:hover {
    color: #49AFDA;
    border-radius: 10px;
    border-color: #49AFDA;
    font-size: 20px !important;
}
.bg-dark-blue {
    background-color: #233648 !important;
}
</style>